import React from "react";
import "./Skills.css";

const categories = [
  {
    title: "Frontend",
    skills: [
      "React 19", "React Hooks", "React Router", "Redux", "Context API",
      "TypeScript", "Tailwind CSS", "Bootstrap", "Recharts", "React Leaflet",
    ],
  },
  {
    title: "Backend",
    skills: [
      "Django", "Django REST Framework", "FastAPI", "Flask", "Laravel",
      "REST APIs", "JWT", "RBAC", "WebSocket", "Socket.IO", "SSE",
    ],
  },
  {
    title: "Languages",
    skills: [
      "JavaScript (ES2023+)", "TypeScript", "Python", "Java", "SQL", "C++", "Go", "PHP",
    ],
  },
  {
    title: "Databases",
    skills: [
      "PostgreSQL", "MySQL", "MongoDB", "InfluxDB", "Redis", "FAISS", "ChromaDB",
    ],
  },
  {
    title: "DevOps & Tools",
    skills: [
      "Docker", "Docker Compose", "Git", "GitLab CI/CD", "Apache Kafka",
      "Postman", "SMTP", "Query Optimisation", "Database Indexing",
    ],
  },
  {
    title: "AI & GenAI",
    skills: [
      "LLM API Integration", "Prompt Engineering", "RAG", "LangChain",
      "Generative AI", "Vector Databases", "OpenAI",
    ],
  },
];

function Skills() {
  return (
    <section id="skills" className="skills section-band">
      <div className="section-inner">
        <header className="section-header">
          <div className="section-label">Skills</div>
          <h2 className="section-title">
            Technical <em>Stack</em>
          </h2>
          <p className="section-subtitle">
            React, TypeScript, Django, FastAPI, and real-time data systems — from frontend dashboards to GenAI pipelines.
          </p>
        </header>

        <div className="skills__grid">
          {categories.map((cat) => (
            <div key={cat.title} className="skill-cat ui-card reveal">
              <h3 className="skill-cat__title">{cat.title}</h3>
              <div className="skill-cat__chips">
                {cat.skills.map((s) => (
                  <span key={s} className="tag">{s}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
